module.exports = __webpack_public_path__ + "img/ic-eye-close.2b434669.svg";